import React from "react";
import { VirtualAccountLoadingContainer } from "../../Wallet/style";
import { ReactComponent as PendingIcon } from "../../../../assets/icons/pending-icon.svg";

type Prop = {
    heading: string;
    subHeading: string;
}

export default function LoadingVirtualAccount({ heading, subHeading }: Prop) {
    return (
        <VirtualAccountLoadingContainer>
            <PendingIcon width={"35px"} height={"50px"} />
            <h1>
                {heading}
            </h1>
            <p>
                {subHeading}
            </p>
        </VirtualAccountLoadingContainer>
    )
}